import React, { memo } from 'react'
import clsx from 'clsx'
import { Box, Grid, Paper } from '@material-ui/core'
import EditableHTML from '@v4/components/common/EditableHTML'
import SignUpForm from '@v4/components/common/Form/SignUpForm'
import SortHandler from '@v4/components/common/SortHandler'
import Image from '@v4/components/common/Image'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useForm2 } from './Form2.hooks'

const Form2 = props => {
	const [
		{
			classes,
			withBgImage,
			withImage,
			direction,
			placeholderColor,
			textShadow,
			image,
			isMobile,
			isCenter,
			formImage,

			buttonText,
			buttonTextConfig,
			buttonTextEditable,
			title,
			titleConfig,
			alignment,
			text,
			textConfig,
			titleEditable,
			textEditable,
			buttonTextKey,
			titleKey,
			textKey,
		},
		{
			handleImageClick,

			handleTextClick,
			handleTitleClick,
			handleButtonClick,
			handleTextChange,
			handleTitleChange,
			handleButtonTextChange,
		},
	] = useForm2(props)

	const textComponent = (
		<EditableContainer
			visible={!!text}
			white={withBgImage}
			fieldConfig={textConfig}
			onAdd={handleTextChange}
			editable={textEditable}
		>
			<Box color="text.secondary">
				<EditableHTML
					key={textKey}
					className={clsx(classes.text, 'form2-text-block')}
					gutterBottom
					white={withBgImage}
					align={PageMetaData.ALIGNMENT.LEFT}
					html={text}
					editable={textEditable}
					onClick={handleTextClick}
					onChange={handleTextChange}
					shadow={withBgImage}
					textShadow={textShadow}
				/>
			</Box>
		</EditableContainer>
	)

	const formComponent = (
		<Paper className={clsx(classes.paper, 'form2-form-card')}>
			<Box className={clsx(classes.formBox, 'form2-form-wrapper')}>
				<SignUpForm
					placeholderColor={placeholderColor}
					buttonText={buttonText}
					buttonTextConfig={buttonTextConfig}
					buttonTextEditable={buttonTextEditable}
					onButtonTextChange={handleButtonTextChange}
					title={title}
					titleConfig={titleConfig}
					titleEditable={titleEditable}
					usePaperColors
					className="form2-form"
					onTitleClick={handleTitleClick}
					onButtonClick={handleButtonClick}
					onTitleChange={handleTitleChange}
					titleKey={titleKey}
					buttonTextKey={buttonTextKey}
					image={formImage}
				/>
			</Box>
		</Paper>
	)

	const mobileImage = <Image metaData={image} className={classes.mobileImage} onClick={handleImageClick} />

	return (
		<>
			{withBgImage && (
				<Image
					className={clsx(classes.background, 'form2-background')}
					metaData={image}
					isBackground
					onClick={handleImageClick}
				/>
			)}
			<Grid container className={clsx(classes.root, classes[alignment], 'form2')} spacing={2}>
				{isMobile ? (
					<SortHandler key="mobile" direction={direction}>
						{withImage && (
							<Grid item xs={12} className="form1-image-container">
								{mobileImage}
							</Grid>
						)}
						<Grid item xs={12} className={clsx(classes.mobileContent, 'form1-content')}>
							{textComponent}
							{isCenter && <div className={clsx(classes.imageWrap)}>{mobileImage}</div>}
							{formComponent}
						</Grid>
					</SortHandler>
				) : (
					<SortHandler key="desktop" direction={direction}>
						<Grid className={clsx(classes.content, 'form2-text-container')} item xs={12} md={6} key="text">
							{textComponent}
						</Grid>
						<Grid item md={1} className={classes.empty} />
						<Grid item md={5} xs={12} key="form" className="form2-form-container">
							{formComponent}
						</Grid>
					</SortHandler>
				)}
			</Grid>
		</>
	)
}

Form2.propTypes = {
	metaData: PropTypes.shape({
		backgroundImage: PropTypes.instanceOf(PageMetaData),
		alignment: PropTypes.instanceOf(PageMetaData),
		column: PropTypes.instanceOf(PageMetaData),
		placeholderColor: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		formHeader: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Form2)
